<template>
  <div
    id="crumbs"
    @mouseenter="openTagDropdown = true"
    @mouseleave="openTagDropdown = false"
    :class="{ 'crumbs-ca-agent': auth.user.role === 7 }"
  >
    <!--  <div v-if="showOverall && showPopup" class="tag-table">

             -- <div class="table-responsive">
                   <table class="table">
                     <tbody>
                     <tr>
                       <td> {{stats}} / {{sumOveral().ov_count}}</td>
                       <td>CR: {{((sumOveral().ov_count)/stats).toFixed(2) }} |  </td>
                     </tr>e
                     </tbody>
                   </table>
                 </div>
             </div>-->
    <div class="btn-group btn-group-sm" role="group" aria-label="First group">
      <button
        type="button"
        @mouseenter="openSubWSecond('cc')"
        @mouseleave="closeSubWSecond('cc')"
        class="btn btn-sc"
        @click="filterSingleTag('coming', 'cc')"
      >
        <!--        @click="[openSubW('coming', 'cc'), triggerPreset('CA_F', 'TODAY')]"-->

        <!--        @click="openSubW('coming', 'cc')"-->
        <!--        @click.stop="filterSingleTag('coming', 'cc')"-->

        <!--        :class="{-->
        <!--        'greyed-out': checkIfDisable(['am', 'mc'], this.activeTags),-->
        <!--        'greyed-out':-->
        <!--        selectedMainTab !== 'clients' ||-->
        <!--        selectedMainTab === 'bn' ||-->
        <!--        greyOutTag('cc', selectedMainTab)-->
        <!--        }"-->

        {{ leftEar == 0 ? "0" : leftEar }}

        <!--          {{ leftEar }} CC-->
        <!--        <span class="slide-btn" v-if="slideBtn.cc"-->
        <!--              @click="$emit('regular')"-->
        <!--          ><div class="arrow">-->
        <!--                <span></span>-->
        <!--                <span></span>-->

        <!--</div><i class="fas fa-bars"></i-->
        <!--        ></span>-->
        <!--        <span-->
        <!--          class="reset-btn"-->
        <!--          v-if="resetBtn.cc"-->
        <!--          @click.stop="closeResetBtn('cc')"-->
        <!--          ><i class="fas fa-times"></i>-->
        <!--        </span>-->
        <div class="bb-sub-menu" v-if="checkSubMenuMode('cc')">
          <!--          <div-->
          <!--            class="bb-sub-menu-ms"-->
          <!--            @click.stop="openMsW('cc')"-->
          <!--            v-tooltip="{ content: `Open multi-select` }"-->
          <!--          >-->
          <!--            <div class="cc-color bb-item">-->
          <!--              <i class="fas fa-bars"></i>-->
          <!--            </div>-->
          <!--            <div class="fake-column cc-color"></div>-->
          <!--          </div>-->
          <div
            class="bb-sub-menu-reset"
            @click.stop="closeResetBtnW('cc')"
            v-tooltip="{ content: `Reset` }"
          >
            <div class="cc-color bb-item">
              <i class="fas fa-times"></i>
            </div>
            <div class="fake-column cc-color"></div>
          </div>
        </div>
        <!--        <div class="bb-sub-menu" v-if="checkIfSecondView('cc')">-->
        <!--          <div-->
        <!--            class="bb-sub-menu-ms"-->
        <!--            @click.stop="filterMultipleTags('coming', 'cc')"-->
        <!--            v-tooltip="{ content: `Productivity` }"-->
        <!--          >-->
        <!--            <div class="cc-color bb-item">-->
        <!--              <div class="first-circle"></div>-->
        <!--              <div class="second-circle"></div>-->
        <!--              <div class="fake-column cc-color"></div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div-->
        <!--            v-if="checkNumbersOfCalendarsSelected() === 1"-->
        <!--            class="bb-sub-menu-ms"-->
        <!--            @click.stop="mergeAllDates('cc', 'coming', shortCutsToBlocks)"-->
        <!--            v-tooltip="{-->
        <!--              content: `Use the same selected dates with this new selection`-->
        <!--            }"-->
        <!--          >-->
        <!--            &lt;!&ndash;          @click.stop="filterMultipleTags('regular', 'ld')"&ndash;&gt;-->

        <!--            <div class="cc-color bb-item">-->
        <!--              <div class="first-circle-tot"></div>-->
        <!--              <div class="second-circle-tot"></div>-->
        <!--              <div class="fake-column-tot cc-color"></div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div-->
        <!--            class="bb-sub-menu-reset"-->
        <!--            @click.stop="filterSingleTag('coming', 'cc')"-->
        <!--            v-tooltip="{ content: `Disregard previous selections` }"-->
        <!--          >-->
        <!--            <div class="cc-color bb-item">-->
        <!--              <div class="first-circle first-circle-right"></div>-->
        <!--              <div class="second-circle second-circle-right"></div>-->
        <!--              <div class="fake-column cc-color"></div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="bb-title-wrapper upper-title">
          <span class="">next</span>
        </div>
        <!--                <div class="tags-dropdown" v-if="openTagDropdown && !checkSubMenuMode('cc') && !checkIfSecondView('cc')">-->
        <div class="tags-dropdown" v-if="false">
          <TagsDropdown
            :btnColors="btnColors"
            @presetTrigger="emitPresetTrigger"
          />
        </div>

        <!--        <div-->
        <!--          class="next-call-reminder-popup blinking"-->
        <!--          v-if="showReminder && CheckUserPermission([7])"-->
        <!--        >-->
        <!--          You have a coming call-->
        <!--        </div>-->
      </button>
    </div>

    <!--    <a class="table-main-tag"  :style="btnStyles" href="javascript:void(0);"-->
    <!--      ><span @click="$emit('regular')" class="">{{ text }} {{ kFormatter(stats) }}</span>-->
    <!--      <div-->
    <!--        v-if="!queryObject.group_assigned && leftEar > 0"-->
    <!--        title="Coming Calls"-->
    <!--        @click="$emit('coming')"-->
    <!--        :style="btnCommingStyles"-->
    <!--        class="dot-left"-->
    <!--      >-->
    <!--        {{ leftEar }}-->
    <!--      </div>-->
    <!--      <div-->
    <!--        v-if="!queryObject.group_assigned && rightEar > 0"-->
    <!--        title="Missed Calls"-->
    <!--        @click="$emit('missed')"-->
    <!--        :style="btnMissedStyles"-->
    <!--        class="dot-right"-->
    <!--      >-->
    <!--        {{ rightEar }}-->
    <!--      </div>-->
    <!--      <div-->
    <!--        v-if="!queryObject.group_assigned && todayEar > 0"-->
    <!--        title="Today Calls"-->
    <!--        @click="$emit('today')"-->
    <!--        :style="btnTodayStyles"-->
    <!--        class="dot-bottom-left"-->
    <!--      >-->
    <!--        {{ todayEar }}-->
    <!--      </div>-->
    <!--      <div-->
    <!--        v-if="!queryObject.group_assigned && autoMissedEar > 0"-->
    <!--        title="Auto Missed Calls"-->
    <!--        @click="$emit('auto_missed')"-->
    <!--        :style="btnAutoMissedStyles"-->
    <!--        class="dot-bottom-right"-->
    <!--      >-->
    <!--        {{ autoMissedEar }}-->
    <!--      </div>-->
    <!--    </a>-->
  </div>
</template>

<script>
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import {mapGetters, mapState} from "vuex";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import TagsDropdown from "./TagsDropdown.component";

export default {
  name: "NextCallsBreadcrumbButton",
  components: {
    TagsDropdown
  },
  props: {
    ifCalendarSelected: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    filtersBarArr: {
      type: Array
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },

    disabledMissed: {
      type: Boolean,
      required: false
    },
    disabledAutoMissed: {
      type: Boolean,
      required: false
    },
    disabledComming: {
      type: Boolean,
      required: false
    },
    disabledToday: {
      type: Boolean,
      required: false
    },
    stats: {
      type: Number,
      required: false
    },
    statsOverall: {
      type: Array,
      required: false
    },
    showOverall: {
      type: Boolean,
      required: false
    },
    earRight: {
      type: Boolean,
      required: false,
      default: false
    },
    earLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    switchPlaces: {
      type: Boolean,
      required: false,
      default: false
    },
    leftEar: {
      type: Number,
      required: false
    },
    rightEar: {
      type: Number,
      required: false
    },
    todayEar: {
      type: Number,
      required: false
    },
    autoMissedEar: {
      type: Number,
      required: false
    },
    queryObject: {
      type: Object
    }
  },
  data() {
    return {
      calendarForPreset: "CA_F",

      btnColors: {
        backgroundColor: "#ffa400",
        color: "white"
      },
      openTagDropdown: false,
      slideBtn: {
        sc: false,
        cc: false,
        tc: false,
        am: false,
        mc: false
      },
      resetBtn: {
        sc: false,
        cc: false,
        tc: false,
        am: false,
        mc: false
      },
      secondClick: {
        sc: false,
        cc: false,
        tc: false,
        am: false,
        mc: false
      },
      showPopup: false,
      yellow: "#fbc02d",
      red: "#ba000d",
      lightRed: "#af4448",
      grey: "#546e7a",
      main: "#fa8100",
      intervals: [],
      totalSum: "",
      showReminder: false
    };
  },
  mixins: [breadButtonsFunctionsUtil, calendarCheck, UsersPermissionCheck],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "totalSumForCrumbBtn",
      "shortCutsToBlocks"
    ]),
    btnStyles() {
      return {
        "--bg-color": this.disabled ? "#546e7a" : this.bgColor,
        "--hover-on-disable": this.disabled ? "-3px" : "0px",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnMissedStyles() {
      return {
        "--missed-bg-color": this.disabledMissed ? this.grey : this.red,
        "--hover-on-disable": this.disabledMissed ? "-3px" : "0px",
        "--font-weight": this.disabledMissed ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnAutoMissedStyles() {
      return {
        "--auto-missed-bg-color": this.disabledAutoMissed
          ? this.grey
          : this.lightRed,
        "--hover-on-disable": this.disabledAutoMissed ? "-3px" : "0px",
        "--font-weight": this.disabledAutoMissed ? "bold" : "normal",
        "--txt-color": "black",
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnCommingStyles() {
      return {
        "--coming-bg-color": this.disabledComming ? this.grey : this.yellow,
        "--hover-on-disable": this.disabledComming ? "-3px" : "0px",
        "--font-weight": this.disabledComming ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnTodayStyles() {
      return {
        "--today-bg-color": this.disabledToday ? this.grey : this.main,
        "--hover-on-disable": this.disabledToday ? "-3px" : "0px",
        "--font-weight": this.disabledToday ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },
  watch: {
    totalSumForCrumbBtn: function() {
      this.totalSum = this.totalSumForCrumbBtn;
    },
    rightEar: function() {
      if (this.rightEar > 0) {
        this.intervals.push(
          setInterval(() => {
            const yellow = "#fbc02d";
            const red = "#c62828";
            const grey = "#546e7a";
            this.red = grey;
            //  let that = this;
            setTimeout(() => {
              this.red = red;
            }, 1500);
          }, 3000)
        );
      }
      if (this.rightEar < 1) {
        for (let i = 0; i < this.intervals.length; i++) {
          clearInterval(this.intervals[i]);
        }
        this.intervals = [];
      }
    },
    autoMissedEar: function() {
      if (this.autoMissedEar > 0) {
        this.intervals.push(
          setInterval(() => {
            const yellow = "#fbc02d";
            const red = "#af4448";
            const grey = "#546e7a";
            this.lightRed = grey;
            //  let that = this;
            setTimeout(() => {
              this.lightRed = red;
            }, 1700);
          }, 3200)
        );
      }
      if (this.autoMissedEar < 1) {
        //console.log("stop")
        for (let i = 0; i < this.intervals.length; i++) {
          clearInterval(this.intervals[i]);
        }
        this.intervals = [];
      }
    },
    leftEar: function() {
      if (this.leftEar > 0) {
        // console.log("bigger")
        this.intervals.push(
          setInterval(() => {
            const yellow = "#fbc02d";
            const red = "#c62828";
            const grey = "#546e7a";
            this.yellow = grey;
            // let that = this;
            setTimeout(() => {
              this.yellow = yellow;
            }, 1500);
          }, 3000)
        );
      }
      if (this.leftEar < 1) {
        //console.log("stop")
        for (let i = 0; i < this.intervals.length; i++) {
          clearInterval(this.intervals[i]);
        }
        this.intervals = [];
      }
    }
  },
  methods: {
    // openSlideBtn(id) {
    //   this.slideBtn[id] = true;
    // },
    // closeSlideBtn(id) {
    //   this.slideBtn[id] = false;
    // },
    // closeResetBtn(id) {
    //   this.resetBtn[id] = false;
    //   this.$emit('resetSelectors')
    //
    // },
    // emitTrigger(title, id) {
    //   this.$emit(title);
    //   this.resetBtn[id] = true;
    // },
    /*      sumOveral(){
                         // return this.statsOverall.map(item => item)
                        // return this.statsOverall.map.reduce((a, b) => a + b, 0)
                       return  this.statsOverall.reduce((a, b) => ({ov_count: a.ov_count + b.ov_count}));

                          //this.statsOverall.reduce(function (a, b) {
                       //     return {bod_count: a.bod_count + b.bod_count}; // returns object with property x
                        //  })
                        },
                      sumOveral2(){
                        // return this.statsOverall.map(item => item)
                        // return this.statsOverall.map.reduce((a, b) => a + b, 0)
                        return  this.statsOverall.reduce((a, b) => ({ov_count_2: a.ov_count_2 + b.ov_count_2}));

                        //this.statsOverall.reduce(function (a, b) {
                        //     return {bod_count: a.bod_count + b.bod_count}; // returns object with property x
                        //  })
                      },*/
    emitPresetTrigger(preset) {
      this.triggerPreset(this.calendarForPreset, preset);
        this.openSubW("coming", "cc");
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
    },
    triggerCallReminder() {
      setInterval(() => {
        if (this.leftEar > 0) {
          this.showReminder = true;
          setTimeout(() => {
            this.showReminder = false;
          }, 10000);
        }
      }, 60000);
    }
  },
  mounted() {
    this.triggerCallReminder();

    // $(document).ready(function() {
    //   $('[data-toggle="tooltip"]').tooltip({ container: "body" });
    //
    //   $('[data-toggle="tooltip"]').tooltip();
    // });
  }
};
</script>

<style lang="scss" scoped>
$btnColor: #fb9324;
$btnColorCC: #ffa400;
$btnColorTC: #fc6a03;
$btnColorAM: #c62828;
$btnColorMC: #cc5801;
$btnColorChild: #009147;
$color: var(--bg-color);
$missedColor: var(--missed-bg-color);
$comingColor: var(--coming-bg-color);
$autoMissedColor: var(--auto-missed-bg-color);
$todayColor: var(--today-bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  width: 104%;
  /*margin-right: 10px;*/
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  width: 70px; //70px;
  line-height: 16pt;
  background: $color;
  padding: 0 3px 0 4px;
  border-color: #ffa400;
  position: relative;
  margin: 0 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-family: "Montserrat" !important;
  font-weight: 500;
  /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
  transition: all 0.3s ease-in-out;
}

#crumbs a:hover {
  /*transform: scale(1.1);*/
  /*<!--top: -3px;-->*/
}

.tag-table {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.dot-right {
  height: 20px;
  width: 20px;
  /*border: 1px solid #c62828;*/
  border-radius: 5px;

  /*color: #c62828;*/
  /*border-radius: 50%;*/
  bottom: 30px;
  right: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
  background-color: #cd1111;
  transition: all 0.1s ease-in-out;
}

.dot-right:hover {
  transform: scaleY(1.1);
  /*background-color: #90a4ae;*/
}

.dot-left {
  height: 20px;
  width: 20px;
  border: 1px solid #fbc02d;
  border-radius: 5px;

  /*color: #fbc02d;*/
  background-color: #fbc02d;
  bottom: 30px;
  left: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-left:hover {
  transform: scaleY(1.1);

  /*background-color: #90a4ae;*/
}

.dot-bottom-left {
  height: 20px;
  width: 20px;
  /*border: 1px solid #fa8100;*/
  border-radius: 5px;

  /*color: #fa8100;*/
  /* border-radius: 50%; */
  top: 30px;
  right: 50px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
  background-color: #fa8100;
}

/* background-color: $autoMissedColor; */
.dot-bottom-right {
  height: 20px;
  width: 24px;
  /*border: 1px solid #af4448;*/
  border-radius: 5px;

  /*#fbc02d;*/
  /*color: #af4448;*/
  /*border-radius: 50%;*/
  top: 30px;
  right: 0;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
  background-color: #cd1111;
}

.dot-bottom-left:hover {
  transform: scaleY(1.1);

  /*background-color: #90a4ae;*/
}

.dot-bottom-right:hover {
  /*transform: scale(1.05);*/
  /*background-color: #90a4ae;*/
}

.table-main-tag {
  /*border-radius: 0px;*/
}

/*.tagNameDesign {*/
/*  border: 1px solid white;*/
/*  border-radius: 5px;*/
/*  padding: 2px 4px;*/
/*  margin-right: 3px;*/
/*  height: 80%;*/
/*}*/
/*.btn-sc*/
/*{ color: #ffffff; background-color: #fa8100; border-color: #d16e04; }*/
/*.btn-sc:hover, .btn-sc:focus, .btn-sc:active, .btn-sc.active, .open .dropdown-toggle.btn-sc*/
/*{ color: #ffffff; background-color: #fa8100; border-color: #d16e04; }*/

.btn-sc {
  font-size: 10px;
  color: #ffffff;
  /*background-color: #fb9324;*/
  background-color: #ffa400;
  //border-color: $btnColorCC;
  transition: all 0.2s ease-in;
  /*min-width: 45px;*/
  width: 100%;
  /*margin-right: 10px;*/
  border-radius: 5px !important;
}

.btn-sc:hover,
.btn-sc:focus,
.btn-sc:active,
.btn-sc.active,
.open .dropdown-toggle.btn-sc {
  outline: none;
}

.btn-sc:focus,
.btn-sc:active,
.btn-sc.active {
  /*-moz-box-shadow: inset 0 0 5px 5px #fa8100;*/
  /*-webkit-box-shadow: inset 0 0 5px 5px#fa8100;*/
  /*box-shadow: inset 0 0 5px 5px #fa8100;*/
  z-index: 0 !important;
}

.btn-sc:nth-of-type(2) {
  /*COming calls*/
  background-color: #ed7014;
  border-color: #ed7014;
  border-bottom-color: #ed7014;
  border-top-color: #ed7014;
}

.btn-sc:nth-of-type(3) {
  /*Today call*/
  background-color: #fc6a03;
  border-color: #fc6a03;
  border-bottom-color: #fc6a03;
  border-top-color: #fc6a03;
}

.btn-sc:nth-of-type(4) {
  /*Fake button*/
  background-color: #c62828;
  border-color: #c62828;
  border-bottom-color: #c62828;
  border-top-color: #c62828;
}

.btn-sc:nth-of-type(5) {
  /* Auto Missed calls*/

  background-color: #cc5801;
  border-color: #cc5801;
  border-bottom-color: #cc5801;
  border-top-color: #cc5801;
  border-right-color: #cc5801;
}

.btn-sc:nth-of-type(6) {
  /* Missed calls*/

  background-color: #b2560d;
  border-color: #b2560d;
  border-bottom-color: #b2560d;
  border-top-color: #b2560d;
  border-right-color: #b2560d;
}

.slide-btn {
  position: absolute;
  top: 24px;
  background-color: inherit;
  width: 105%;
  left: -1px;
  border-radius: 0px 0px 30px 0px;
}

.reset-btn {
  position: absolute;
  top: -5px;
  right: 0px;
  color: grey;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  /*transform: scale(1.3);*/
  color: red;
}

.arrow {
  position: absolute;
  top: 13px;
  left: -3px;
  /*transform: translate(50%,50%);*/
  transform: rotate(90deg);
}

.arrow span {
  display: block;
  width: 6px;
  height: 6px;
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  transform: rotate(45deg);
  margin: -10px;
  animation: animate 2s infinite;
}

.arrow span:nth-child(2) {
  animation-delay: -0.2s;
}

.arrow span:nth-child(3) {
  animation-delay: -0.4s;
}

@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-5px, -5px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(0px, 0px);
  }
}

#crumbs .btn-group-sm {
  display: flex;
}

.btn-sc:hover {
  transform: scale(1.1);
}

span.bb-title {
  position: absolute;
  top: 25px;
  color: black;
  left: 0px;
  font-size: 8px;
}

div.bb-title-wrapper {
  //position: absolute;
  color: white;
  font-size: 8px;
  width: 100%;
  top: 25px;
  left: 0px;
  text-align: center;
}

div.bb-title-wrapper:first-child {
  /*font-size: 7px;*/
}

.crumbs-ca-agent {
  width: 108%;
}

.upper-title {
  text-transform: uppercase;
}

.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
}

/*
    .bb-sub-menu-reset:after {
      background-color: inherit;
      content: " ";
      position: absolute;
      top: 20px;
      height: 10px;
      width: 8px;
      color: inherit;
      left: 6px;
      color: $btnColor;
    }
    */
/*<!--.bb-sub-menu-ms:after {-->*/
/*<!--  background-color: inherit;-->*/
/*<!--  content: " ";-->*/
/*<!--  position: absolute;-->*/
/*<!--  top: 20px;-->*/
/*<!--  height: 10px;-->*/
/*<!--  width: 8px;-->*/
/*<!--  color: inherit;-->*/
/*<!--  left: 48px;-->*/
/*<!--  color: $btnColor;-->*/
/*<!--}-->*/
.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.sc-color {
  background-color: #ffa400;
}

.cc-color {
  background-color: $btnColorCC;
}

.tc-color {
  background-color: $btnColorTC;
}

.am-color {
  background-color: $btnColorAM;
}

.mc-color {
  background-color: $btnColorMC;
}

.left-border,
.right-border {
  background-color: white;
  /* border: 1px red solid; */
  height: 10px;
  width: 7px;
  position: absolute;
}

.left-border {
  left: 0px;
}

.right-border {
  left: 20px;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.first-circle-tot {
  background-color: inherit;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
  border: 1px solid white;
}

.second-circle-tot {
  border: 1px solid white;
  background-color: inherit;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.fake-column-tot {
  width: 8px;
  /*height: 10px;*/
  height: 23px;
  margin-left: 6px;
}

.next-call-reminder-popup {
  position: absolute;
  background-color: #ed7014;
  left: 0;
  top: -25px;
  height: 30px;
  width: max-content;
  padding: 3px 5px;
  border-radius: 5px;
}

.blinking {
  -webkit-animation: 2s blink ease-in-out infinite;
  -moz-animation: 2s blink ease-in-out infinite;
  -ms-animation: 2s blink ease-in-out infinite;
  -o-animation: 2s blink ease-in-out infinite;
  animation: 2s blink ease-in-out infinite;
  animation: 2s blink ease-in-out infinite;
}

@keyframes blink {
  from,
  to {
    opacity: 0;
    transform: scale(1);
    top: 0px;
  }

  50% {
    opacity: 1;
    transform: scale(1.5);
    top: -55px;
  }
}

@-moz-keyframes blink {
  from,
  to {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}

@-webkit-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@-ms-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@-o-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}
</style>
